export default function genererDossierDuProjet() {
  return {
    libelle: null,
    projetId: null,
  };
}
